export { default } from './PortfolioItem';


// WEBPACK FOOTER //
// ./src/components/PortfolioItem/index.js